<template>
    <div><!--bg-gradient-warning-->
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape  shape-skew" style="background-image: linear-gradient(to bottom right, black, #002A46);">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container mt-5">
                <div class="row row-grid align-items-center mt-5">
                    <div class="col-md-6" >
						<router-link slot="brand" class="nav-link" to="/profile/phantom">
							<div class="card bg-default shadow border-0">
								<img v-lazy="'img/theme/Fixed/Phantom.png'" class="card-img-top">
								<blockquote class="card-blockquote">
									<svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 0 0"
										 class="svg-bg">
										<polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
										<polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
									</svg>
									<h4 class="display-3 font-weight-bold text-white">Phantom</h4>
									<p class="lead text-italic text-white" style="font-size: 12px">Phantom (Philip Terry)  is a professional music artist and actor, based out of Cincinnati, Ohio....</p>
								</blockquote>
							</div>
						</router-link>
                    </div>
                    <div class="col-md-6">
					<router-link slot="brand" class="nav-link" to="/profile/persona">
                        <div class="card bg-default shadow border-0">    
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 -583 -93"
                                     class="svg-bg">
                                    <polygon points="0,-52 -583,-95 0,-95" class="fill-default"></polygon>
                                    <polygon points="0,-42 -583,-95 -683,0 0,-95" opacity=".2" class="fill-default"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">Persona</h4>
                                <p class="lead text-italic text-white" style="font-size: 12px">Persona's (Matthew Terry) interest in music began in his early years. He played as a percussionist..</p>
                            </blockquote>
							<img v-lazy="'img/theme/Fixed/Persona.png'" class="card-img-top">
						</div> 
					</router-link>   
                    </div>
                </div>
                <div class="row row-grid align-items-center mt-5">
                    <div class="col-md-6">
						<router-link slot="brand" class="nav-link"  to="/profile/ky babie" >
                        <div class="card bg-default shadow border-0">  
							<img v-lazy="'img/theme/Fixed/kybabie.png'" class="card-img-top">
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 -583 -93"
                                     class="svg-bg">
                                    <polygon points="0,-52 -583,-95 0,-95" class="fill-default"></polygon>
                                    <polygon points="0,-42 -583,-95 -683,0 0,-95" opacity=".2" class="fill-default"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">ky babie</h4>
                                <p class="lead text-italic text-white" style="font-size: 12px">♀Poet • KY / CINCY • #BLM #isupportthegirls </p><br>
                            </blockquote>
                        </div>						
					</router-link>
                    </div>
				    <div class="col-md-6">
						<router-link slot="brand" class="nav-link" to="/profile/logos">
                        <div class="card bg-default shadow border-0">  
							<img v-lazy="'img/theme/Fixed/logos-1.png'" class="card-img-top">
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 -583 -93"
                                     class="svg-bg">
                                    <polygon points="0,-52 -583,-95 0,-95" class="fill-default"></polygon>
                                    <polygon points="0,-42 -583,-95 -683,0 0,-95" opacity=".2" class="fill-default"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">Logos</h4>
                                <p class="lead text-italic text-white" style="font-size: 12px">Logos (Michelob Williamson) is a Cincinnati based artist who was born in Florida...</p>
                            </blockquote>
                        </div>						
					</router-link>
                    </div>
                </div>
			</div>
        </section>
    </div>
</template>
<script>
export default {
  name: "Artist",
  components: {
	  	test () {
			console.log("hello")
		}
  },
	methods: {
		changeartistid (item) {
			this.$store.state.artistid = item
		}
	}
};

</script>
